import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { LoginPageSkeleton } from './Skeleton';

function ProtectedRoute({ children }) {
  const { token, username, bootstrapped } = useAuth();
  const { id, channel } = useParams();
  // Keep the query string through the redirect — campaign links carry ?text=,
  // and dropping it here would silently eat the auto-send.
  const { search } = useLocation();

  if (!bootstrapped) {
    return <LoginPageSkeleton />;
  }

  if (!token || !username) {
    return <Navigate to={`/${id}/${channel}${search}`} replace />;
  }

  return children;
}

export default ProtectedRoute;
